module.exports = __webpack_public_path__ + "img/12_dice[3].22724ba4.png";